import { render } from "./ClientsTable.vue?vue&type=template&id=101b25b3"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"

import "./ClientsTable.vue?vue&type=style&index=0&id=101b25b3&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__